import { fetchEnv } from '../utils/fetchEnv'

export enum LogLevel {
  Debug = 'debug',
  Error = 'error',
}

type Transport = (level: LogLevel, message: string | Error, metadata: any) => void

const consoleTransport: Transport = (level, message, metadata) => {
  const log = level === LogLevel.Error ? console.error : console.log

  log(...[message, metadata].filter(Boolean))
}

class Logger {
  LogLevel = LogLevel

  transports: Transport[] = []

  debug = (message: string | Error, metadata?: any) => {
    this.transport(LogLevel.Debug, message, metadata)
  }

  error = (error: string | Error, metadata?: any) => {
    this.transport(LogLevel.Error, error, metadata)
  }

  addTransport(transport: Transport) {
    this.transports.push(transport)
    return () => {
      this.transports.splice(this.transports.indexOf(transport), 1)
    }
  }

  protected transport(level: LogLevel, message: string | Error, metadata?: any) {
    for (const transport of this.transports) {
      transport(level, message, metadata)
    }
  }
}

export const logger = new Logger()

if (!fetchEnv('PROD')) {
  logger.addTransport(consoleTransport)
}
